import { Box, BoxProps } from '@chakra-ui/react'
import React from 'react'

export default function InsetWrapper({ children, ...rest }: BoxProps) {
    return (
        <Box
            w="full"
            shadow="inset-blue.lg"
            border="1px solid"
            borderColor="gray.200"
            {...rest}
        >
            {children}
        </Box>
    )
}
